/**
 * Content-resolver: geeft de juiste taalvariant van data-content terug.
 * Bron = Nederlands (in de data); voor `en` komt de waarde uit de gegenereerde
 * EN-overlay (en.generated.ts), met NL als fallback. Zo volgt alle content de
 * systeemtaal met Engels als fallback.
 */
import type { Baas, Chakra, Kaart, Origin } from './types';
import type { Houding } from './vn';
import { monoloogVan as monoloogNL, leermomentVan as leermomentNL } from './flavor';
import { EN } from './en.generated';
import type { Taal } from '../i18n';

function ct(key: string, nl: string, taal: Taal): string {
  if (taal === 'en') return EN[key] ?? nl;
  return nl;
}

/* kaarten */
export const kaartNaam = (k: Kaart, taal: Taal) => ct(`c:${k.id}:n`, k.naam, taal);
export const kaartTekst = (k: Kaart, taal: Taal) => ct(`c:${k.id}:t`, k.tekst, taal);

/* bazen */
export const baasTitel = (b: Baas, taal: Taal) => ct(`b:${b.id}:ti`, b.titel, taal);
export const baasMonoloog = (b: Baas, taal: Taal) => ct(`b:${b.id}:m`, monoloogNL(b), taal);
export const baasLeermoment = (b: Baas, taal: Taal) => ct(`b:${b.id}:l`, leermomentNL(b), taal);

/* chakra */
export const codexTekst = (c: Chakra, taal: Taal) => ct(`cx:${c.header.nummer}`, c.codex, taal);
export const wereldNaam = (c: Chakra, taal: Taal) => ct(`w:${c.header.nummer}`, c.wereld, taal);

/* archief */
export const archiefTitel = (id: string, nl: string, taal: Taal) => ct(`a:${id}:ti`, nl, taal);
export const archiefMonoloog = (id: string, nl: string, taal: Taal) => ct(`a:${id}:m`, nl, taal);

/* VN */
export const confrontatieReactie = (chakra: Origin, houding: Houding, nl: string, taal: Taal) =>
  ct(`cr:${chakra}:${houding}`, nl, taal);
export const reflectieVraag = (chakra: Origin, nl: string, taal: Taal) => ct(`r:${chakra}:v`, nl, taal);
export const reflectieAntwoord = (chakra: Origin, i: number, nl: string, taal: Taal) => ct(`r:${chakra}:o${i}`, nl, taal);
export const reflectieLogregel = (chakra: Origin, i: number, nl: string, taal: Taal) => ct(`r:${chakra}:l${i}`, nl, taal);

/* korte vaste lijstjes (header-feiten) — EN naast NL */
const ELEMENT_EN: Record<string, string> = {
  Aarde: 'Earth', Water: 'Water', Vuur: 'Fire', Lucht: 'Air', Ether: 'Ether', Licht: 'Light', Bewustzijn: 'Consciousness',
};
const RESOURCE_EN: Record<string, string> = {
  Stabiliteit: 'Stability', Flow: 'Flow', Wilskracht: 'Willpower', Hartenergie: 'Heart energy', Stemkracht: 'Voice', Helderheid: 'Clarity', Verbinding: 'Connection',
};
export const elementNaam = (nl: string, taal: Taal) => (taal === 'en' ? ELEMENT_EN[nl] ?? nl : nl);
export const resourceNaam = (nl: string, taal: Taal) => (taal === 'en' ? RESOURCE_EN[nl] ?? nl : nl);
